<ap-action-icon
    data-testid="search-menu"
    class="ap-header__navigation-icon ap-header__navigation-icon--search"
    (click)="searchClicked.emit(searchNavigationItem())"
    [ariaLabel]="searchNavigationItem().ariaLabel ?? searchNavigationItem().label"
>
    <ap-icon name="magnifier" size="large"> </ap-icon>
</ap-action-icon>
